import { render, staticRenderFns } from "./TooltipElement.vue?vue&type=template&id=52d0d20a&scoped=true"
import script from "./TooltipElement.vue?vue&type=script&lang=js"
export * from "./TooltipElement.vue?vue&type=script&lang=js"
import style0 from "./TooltipElement.vue?vue&type=style&index=0&id=52d0d20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0d20a",
  null
  
)

export default component.exports